/**
 * 格式化时间
 * @param {String} value 时间戳
 * @param {String} arg 格式化类型
 * @example
 * <div v-format-date="time" arg="YYYY-MM-DD HH:mm:ss"></div>
 * <div v-format-date:YYYY-MM-DD="time" arg="YYYY-MM-DD HH:mm:ss"></div>
 * <div v-format-date:YYYY-MM-DD^HH:mm="time" arg="YYYY-MM-DD HH:mm:ss"></div> ^ 代表空格
 *
 * el: 指令所绑定的元素，可以用来直接操作 DOM 。
 * binding: {
 *  arg: 自定义指令的参数名
 *  value 自定义指令绑定的值。
 *  oldValue 指令绑定的前一个值。
 *  dir 被执行的钩子函数
 *  modifiers：一个包含修饰符的对象。
 * }
 */
import dayjs from 'dayjs';

const format = {
  // 在绑定元素的 attribute 或事件监听器被应用之前调用, 在指令需要附加须要在普通的 v-on 事件监听器前调用的事件监听器时，这很有用
  created(el, binding) {
    el.innerHTML = format.transformTime(el, binding);
  },
  // 当指令第一次绑定到元素并且在挂载父组件之前调用
  // beforeMount() {},
  // 在绑定元素的父组件被挂载后调用
  // mounted() {},
  // 在更新包含组件的 VNode 之前调用
  beforeUpdate(el, binding) {
    el.innerHTML = format.transformTime(el, binding);
  },
  // 在包含组件的 VNode 及其子组件的 VNode 更新后调用
  // updated() {},
  // 在卸载绑定元素的父组件之前调用
  // beforeUnmount() {},
  // 当指令与元素解除绑定且父组件已卸载时, 只调用一次
  // unmounted() {},

  transformTime(el, binding) {
    const { value } = binding;
    let { arg = 'YYYY-MM-DD HH:mm:ss' } = binding;
    if (!value) return '-';
    if (arg.indexOf('^') !== -1) {
      arg = arg.replace('^', ' ');
    }
    return dayjs(value).format(arg);
  }
};
export default format;
